import axios from 'axios';

export default {
  namespaced: true,

  state() {
    return {
      item: {},
      isVideoresume: false,
      loaded: false,
      error: false,
      token: null,
      response: null
    };
  },

  mutations: {
    set_item(state, v) {
      state.item = v;
    },
    set_videoresume(state, v) {
      state.isVideoresume = v.is_videoresume;
    },
    set_loaded(state, v) {
      state.loaded = v;
    },
    set_token(state, v) {
      state.token = v;
    },
    set_response(state, v) {
      state.response = v;
    },
    set_error(state, v) {
      state.error = v;
    }
  },

  actions: {
    load(context, id) {
      context.commit('set_loaded', false);
      context.commit('set_error', false);
      return axios
        .get(`/1.0/interviews/${id}`)
        .then(r => {
          const item = r.data.data[0];
          if (item.stage.id === 'finished') {
            // отсечение. Если стоит пройдено, то выпиливаются все остальные стеджи
            item.active_modules = item.active_modules.filter(module => module.is_finished);
          }
          // save processName from Meta if it is
          if (item.meta.active_process !== undefined) {
            context.commit('process/setName', item.meta.active_process, { root: true });
          }

          context.commit('set_token', id);
          context.commit('set_item', item);
          context.commit('set_videoresume', item);
          context.commit('set_loaded', true);
          return Promise.resolve(r);
        })
        .catch(e => {
          context.commit('set_error', e);
          context.commit('set_loaded', true);
          return Promise.reject(e);
        });
    },

    loadResponse(context, token) {
      return axios
        .get(`/1.0/interviews/${token}/get-candidate-link`)
        .then(r => {
          const data = r.data.data[0];
          context.commit('set_response', data.token);
          return Promise.resolve(r);
        })
        .catch(e => {
          context.commit('set_error', e);
          return Promise.reject(e);
        });
    }
  },

  getters: {
    item: state => state.item,
    isVideoresume: state => state.isVideoresume,
    loaded: state => state.loaded,
    error: state => state.error,
    token: state => state.token,
    response: state => state.response,
    process: state => (state.item.meta ? state.item.meta.active_process : null)
  }
};
